export enum SelectedMenuType {
    OpenItemContextMenu = 0,
    OpenContextMenu = 1,
    CallSelectedItemsMenu = 2
}



// WEBPACK FOOTER //
// ./src/app/models/selected-menu-type.enum.ts